import { User, UserBalance } from './user.model';
import { UserApi } from '../api-typings/users';
import { Entities } from '../store';

export function transformUser(user: any): User {
  return ({
    id: user.id,
    avatar: transformUserImage(user.avatar),
    avatarLarge: transformUserImage(user.avatar_large),
    username: user.username,
    displayName: user.display_name,
    role: user.role,
    profileUrl: `/u/${user.username}.html`
  });
}

export function transformUserImage(image: string): string | undefined {
  return image !== '/img/unknown.png' ? image : undefined;
};

export function transformUserBalances(user: UserApi): Entities<UserBalance> {
  return user.account_balances.balances.reduce(
    (acc, balance) => ({
      ...acc,
      [balance.currency.id]: {
        ...balance,
        primary: balance.currency.code === user.primary_currency.code,
      },
    }),
    {},
  );
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user/user.reducer.ts